<template>
  <div class="login">

    <el-row :gutter="0">
      <el-col :span="8" :offset="0">
        <slot></slot>
      </el-col>
      <el-col :span="16" :offset="0">
        <div class="right-box">
          <div class="top" :style="{ backgroundImage: `url(${img})` }">
            <!-- BG img -->
          </div>
          <div class="bottom">
            <a :href="learnMore.url" target="_blank">
              <el-button type="primary" size="default">Learn More</el-button>
            </a>
            <div>
              <a v-for="item in links" :key="item.id" :href="item.url" target="_blank" class="bottom__link">
                <img :src="item.imageUrl" :alt="item.name" style="height: 40px; object-fit: cover;">
              </a>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import moment from 'moment'
import axios from 'axios'
  export default {
    name: 'TemplateAuth',
    components: {},
    mounted () {
      this.getInfo()
    },
    data() {
      return {
        moment: moment,

        img: '',
        links: [],
        learnMore: {
          imageUrl: '',
          name: '',
          url: ''
        },
      }
    },
    methods: {
      async getInfo () {
        let loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          const { data } = await axios.post(`/api/v1/login-page/get-all`)
          this.img = data.pageData.mainImageUrl
          this.links = data.links
          for (let key in this.learnMore) {
            this.learnMore[key] = data.learnMoreLink[key]
          }
        } catch (error) {
          console.log(error)
        } finally {
          loader.hide()
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
.right-box {
  height: 100vh;
  display: flex;
  flex-direction: column;

  .top {
    flex-grow: 1;
    background-color: #fff;
    // background-image: url('~@/assets/img/login-start-icon.jpg');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }

  .bottom {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    height: 150px;
    background-color: #fff;

    &__link {
      margin: 0 10px;
    }
  }
}
</style>
